// extracted by mini-css-extract-plugin
export default {"container":"LandingSection_container__8ww-Z"};